(() => {
  'use strict';

  const GOOGLE_SCRIPT = 'https://news.google.com/swg/js/v1/publisher.js';

  const init = () => {
    const pageLang = (document.documentElement.lang || '').trim();

    document.querySelectorAll('[google-add-preferred-source-btn]').forEach((button) => {
      if (pageLang) button.setAttribute('data-lang', pageLang);
    });

    if (!document.querySelector('script[data-si-preferred-source-google]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = GOOGLE_SCRIPT;
      script.setAttribute('data-si-preferred-source-google', '');
      document.head.appendChild(script);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();